import React from "react";
import ReactDOM from "react-dom/client";
import RootGate from "./App.jsx";
import "./styles/app.css";

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <RootGate />
  </React.StrictMode>
);
